import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import { basePath } from "./config";
import { toast } from "react-toastify";

const Navbar = () => {
  const [{ activeUser, isEditor }, { setActiveUser }] = useAuth();
  console.log({ activeUser });
  const navigate = useNavigate();

  async function handleLogout() {
    document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    try {
      const data = await fetch(basePath + "logout", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activeUser),
      });

      const res = await data.json();

      if (res.status) {
        setActiveUser(null);
        toast.success(res.message);
        navigate("/login");
      } else {
        setActiveUser(null);
        navigate("/login");
        toast.error(res.message);
      }

      console.log(res);
    } catch (err) {
      toast.error("Error: " + err);
    }
  }

  return (
    <nav id="mainNavBar" className="bg-orange">
      <div className="flex justify-between text-white px-4 items-center h-[60px]">
        <Link to={"/"}>3 Star</Link>
        {activeUser && (
          <>
            <h1>{`${activeUser.name} - ${
              isEditor ? "Editor" : "View Only"
            }`}</h1>
            <div
              onClick={() => {
                handleLogout();
              }}
            >
              logout
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
